import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { userLogin } from '../../store/actions/apiActions'
import { Jackpots } from '../Mobile/Mobile'

const JackpotPage = () => {
	const dispatch = useDispatch()
	const userData = useSelector((state) => state?.userdata, shallowEqual)

	useEffect(() => {
		if (!userData.auth) {
			// anonymous session: this page is embedded standalone in iframes and only
			// needs the jackpot feed, so it must never register as the real account's
			// active session, which would kick that session as a "parallel" login
			dispatch(userLogin(true))
		}

		// Set the background to transparent
		document.body.style.background = 'transparent'

		return () => {
			document.body.style.background = ''
		}
	}, [])

	return (
		<div
			style={{
				display: 'flex',
				width: '100%',
				flexFlow: 'column',
			}}
		>
			<Jackpots />
		</div>
	)
}

export default JackpotPage
